import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * Shown while an admin is viewing the app as a customer (impersonation).
 */
export default function ImpersonationBanner() {
    const navigate = useNavigate();
    const { user, exitImpersonationSession } = useAuth();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const on =
            !!sessionStorage.getItem('impersonation_admin_token') && user?.role === 'Customer';
        setVisible(on);
        document.body.style.paddingTop = on ? '52px' : '';
        return () => {
            document.body.style.paddingTop = '';
        };
    }, [user]);

    if (!visible) return null;

    const detailRaw = sessionStorage.getItem('user_detail');
    let label = 'Customer';
    try {
        const d = JSON.parse(detailRaw || '{}');
        const name = `${d.fname || ''} ${d.lname || ''}`.trim();
        label = name || d.email || 'Customer';
    } catch {
        /* ignore */
    }

    return (
        <div
            className="impersonation-banner"
            style={{
                position: 'fixed',
                left: 0,
                right: 0,
                top: 0,
                zIndex: 2000,
                padding: '10px 16px',
                background: 'linear-gradient(90deg, #16182d 0%, #2a2d4a 100%)',
                color: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexWrap: 'wrap',
                gap: '12px',
                fontSize: '14px',
                boxShadow: '0 2px 12px rgba(0,0,0,0.2)',
            }}
        >
            <span>
                <strong>Support mode:</strong> you are viewing as <strong>{label}</strong>
            </span>
            <button
                type="button"
                className="btn btn-sm"
                style={{
                    background: 'linear-gradient(131deg, #fe8100 -4.12%, #f5ff00 100%)',
                    border: '1px solid #f0c100',
                    color: '#111',
                    fontWeight: 700,
                }}
                onClick={() => exitImpersonationSession(navigate)}
            >
                Back to admin
            </button>
        </div>
    );
}
